import React from "react"

import BackgroundImage from "../../../common/BackgroundImage"

const ClusterEditItemDetails = ({
    title,
    time,
    description,
    image_url,
    onEventChange
}) => (
    <div className="widget">
        <div className="widget-content">
            <h3 className="first-heading">
                <i className="icon icon-headline" />
                Title {!title && <span style={{ color: "red" }}>*</span>}
            </h3>
            <input
                type="text"
                name="title"
                className="form-control"
                placeholder="Title"
                value={title}
                onChange={onEventChange}
                required={true}
            />
            <h3>
                <i className="icon icon-headline" />
                Time
            </h3>
            <input
                type="text"
                name="time"
                className="form-control"
                placeholder="Time"
                value={time.local().format("llll")}
                disabled={true}
            />
            <h3>
                <i className="icon icon-headline" />
                Description{" "}
                {!description && <span style={{ color: "red" }}>*</span>}
            </h3>
            <textarea
                name="description"
                className="form-control"
                placeholder="Description"
                value={description}
                onChange={onEventChange}
                required={true}
            />
            <h3>
                <i className="icon icon-heroimg" />
                Image
            </h3>
            <BackgroundImage
                imageUrl={image_url}
                classList={["item-background-image"]}
            />
        </div>
    </div>
)

export default ClusterEditItemDetails
